export const useAppearanceStore = defineStore("appearanceStore", () => {
  const sideFilterMenu = ref({
    isShown: false,
  });

  return { sideFilterMenu };
});
